import {  toast } from 'react-toastify';

export const Toasts = {
  notify: (message: string) => toast.info(message),
  error: (message: string) => toast.error(message),
  success: (message: string) => toast.success(message),
  warn: (message: string) => toast.warn(message),
};

export function setBackgroundImage(imagePath: string) {
  const imageUrl = `https://image.tmdb.org/t/p/w1280${imagePath}`;
  document.querySelector('.background-image')?.setAttribute('style', `background-image: url(${imageUrl})`);
}